<div class="ipo-card" *ngIf="companyProfile">
   <h5 class="title">Track and analyze key information</h5>
   <p class="subtitle">
      Understand the key IPO metrics including price range, shares offered,
      offer amount, and IPO schedule to make informed investment decisions.
   </p>

   <table class="ipo-table">
      <thead>
         <tr>
            <th colspan="2">IPO metrics</th>
         </tr>
      </thead>
      <tbody>
         <!-- Status -->
         <tr>
            <td>Status</td>
            <td>
               <span class="status-badge">{{
                  companyProfile.ipo_status || "N/A"
               }}</span>
            </td>
         </tr>

         <!-- IPO Price / Price Range -->
         <tr>
            <td>
               {{
                  companyProfile.ipo_status === "Priced"
                     ? "IPO Price"
                     : "Price Range"
               }}
            </td>
            <td>
               {{
                  getCurrencyDisplay(
                     companyProfile.ipo_status === "Priced"
                        ? companyProfile.ipo_priced_price
                        : companyProfile.ipo_price,
                     companyProfile.country
                  )
               }}
            </td>
         </tr>

         <!-- Dynamic Date Row -->
         <!-- Conditionally show Issue Opening Date -->

         <!-- Fallback row for IPO Date -->
         <ng-template #showIpoDate>
            <tr *ngIf="companyProfile.ipo_status !== 'Upcoming'">
               <td>
                  {{
                     companyProfile.ipo_status === "Withdrawn" &&
                     companyProfile.country === "US"
                        ? "Withdrawn Date"
                        : "IPO Date"
                  }}
               </td>
               <td>
                  {{
                     companyProfile.ipo_status === "Priced"
                        ? companyProfile.ipo_priced_date
                           ? (companyProfile.ipo_priced_date
                             | date : "MMMM d, y")
                           : "N/A"
                        : companyProfile.ipo_status === "Withdrawn"
                        ? companyProfile.ipo_withdrwa_date
                           ? (companyProfile.ipo_withdrwa_date
                             | date : "MMMM d, y")
                           : "N/A"
                        : companyProfile.ipo_date
                        ? (companyProfile.ipo_date | date : "MMMM d, y")
                        : "N/A"
                  }}
               </td>
            </tr>
         </ng-template>

         <!-- Listing Date for India if Priced -->
         <tr
            *ngIf="
               companyProfile.country === 'IN' &&
               companyProfile.ipo_status === 'Priced'
            "
         >
            <td>Listing Date</td>
            <td>
               {{
                  companyProfile.ipo_priced_date
                     ? (companyProfile.ipo_priced_date | date : "MMMM d, y")
                     : "N/A"
               }}
            </td>
         </tr>

         <!-- Shares Offered -->
         <tr>
            <td>Shares Offered</td>
            <td>
               {{
                  companyProfile.ipo_numberOfShares === 0
                     ? "-"
                     : companyProfile.ipo_numberOfShares != null
                     ? (companyProfile.ipo_numberOfShares | number)
                     : "N/A"
               }}
            </td>
         </tr>

         <!-- Offer Amount -->
         <tr>
            <td>Offer Amount</td>
            <td>
               {{
                  getCurrencyDisplay(
                     companyProfile.ipo_totalSharesValue,
                     companyProfile.country
                  )
               }}
            </td>
         </tr>

         <tr
            *ngIf="
               companyProfile.country === 'IN' &&
                  (companyProfile.ipo_status === 'Upcoming' ||
                     companyProfile.ipo_status === 'Priced' ||
                     companyProfile.ipo_status === 'Withdrawn');
               else showIpoDate
            "
         >
            <td>Issue Opening Date</td>
            <td>
               {{
                  companyProfile.ipo_open_date
                     ? (companyProfile.ipo_open_date | date : "MMMM d, y")
                     : "N/A"
               }}
            </td>
         </tr>

         <!-- Closing date if status is Upcoming or Priced and country is IN -->
         <tr
            *ngIf="
               companyProfile.country === 'IN' &&
               (companyProfile.ipo_status === 'Upcoming' ||
                  companyProfile.ipo_status === 'Priced' ||
                  companyProfile.ipo_status === 'Withdrawn')
            "
         >
            <td>Issue Closing Date</td>
            <td>
               {{
                  companyProfile.ipo_close_date
                     ? (companyProfile.ipo_close_date | date : "MMMM d, y")
                     : "N/A"
               }}
            </td>
         </tr>
         <tr
            *ngIf="
               companyProfile.country === 'US' &&
               companyProfile.ipo_status === 'Upcoming'
            "
         >
            <td>Expected IPO Date</td>
            <td>
               {{
                  companyProfile.ipo_date
                     ? (companyProfile.ipo_date | date : "MMMM d, y")
                     : "N/A"
               }}
            </td>
         </tr>
      </tbody>
   </table>
</div>
